import axios from 'axios';
import { Message } from 'element-ui'
const request = axios.create({
    baseURL: 'https://www.leadtopone.cn/prod-api',
    timeout: 5000
})

//request 拦截器
//可以自请求发送前对请求做一些处理
//比如统一加token，对请求参数做处理
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'; // 设置请求头
    // do something before request is sent
    return config;
}, error => {
    // do something with request error
    return Promise.reject(error);
});

//response 拦截器
//可以在接口响应后统一处理结果
request.interceptors.response.use(res => {
    if(res.data.code === 200) {
        Message.success("提交成功");
    }else {
        Message.error("提交失败,请稍后重试");
    }
    }
  )
export default request;